import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { EntityId } from '@ngrx/signals/entities';
import { injectAuiToastDefaultOptions } from '../services/aui-toast.service';
import { ToastsStore } from '../store/aui-toast.store';
import { AuiToastItemComponent } from './aui-toast-item.component';

@Component({
    selector: 'aui-toast',
    imports: [CommonModule, AuiToastItemComponent],
    template: ` <div>
        <div
            (mouseleave)="showStacked()"
            [class]="stackClasses()"
            [ngClass]="{
                'flex h-auto flex-col gap-2': true,
            }"
        >
            @for (toast of toasts(); track toast.id; let index = $index; let count = $count) {
                <aui-toast-item
                    (mouseenter)="showFlex()"
                    (closed)="close($event)"
                    [id]="toast.id"
                    [stacked]="stacked"
                    [title]="toast.title || toast.type + ''"
                    [message]="toast.message || ''"
                    [type]="toast.type"
                    [duration]="duration()"
                    [hidden]="
                        (index === 0 && stacked && (toasts().length === 2 || toasts().length === 3)) ||
                        (index === 1 && stacked && toasts().length === 3)
                    "
                    class="left-0 mx-auto transition-all  duration-300 {{ index }}"
                    [ngClass]="{
                        'h-[90px] overflow-hidden':
                            (index === 0 && stacked && (toasts().length === 2 || toasts().length === 3)) ||
                            (index === 1 && stacked && toasts().length === 3),
                        'max-h-[300000px] w-full': !stacked,
                        absolute:
                            (index === 0 && stacked && (toasts().length === 3 || toasts().length === 2)) ||
                            (index === 1 && stacked && toasts().length === 3),
                        '-translate-y-[25%]': index === 0 && stacked && toasts().length === 3,
                        '-translate-y-[14%]':
                            (index === 1 && stacked && toasts().length === 3) ||
                            (index === 0 && stacked && toasts().length === 2),
                        'translate-y-0':
                            (index === 1 && stacked && toasts().length === 2) ||
                            (index === 2 && stacked && toasts().length === 3) ||
                            (toasts().length === 1 && stacked),
                        'left-[10px] w-[320px]': index === 0 && count === 3 && stacked,
                        'left-[5px] w-[330px]':
                            (index === 0 && count === 2 && stacked) || (index === 1 && count === 3 && stacked),
                        'left-[0px] w-[340px]':
                            (index === 0 && count === 1 && stacked) ||
                            (index === 1 && count === 2 && stacked) ||
                            (index === 2 && count === 3 && stacked),
                    }"
                ></aui-toast-item>
            }
        </div>
    </div>`,
})
export class AuiToastComponent {
    toastsStore = inject(ToastsStore);
    toasts = this.toastsStore.toasts;
    stacked = true;
    defaultOptions = injectAuiToastDefaultOptions();
    position = signal(this.defaultOptions.position);
    duration = signal(this.defaultOptions.duration);
    stackClasses = computed(() => {
        const tailwindClasses = ['w-[340px]', 'fixed', 'z-[100000]'];
        const position = this.position();
        if (position === 'bottom-right') {
            tailwindClasses.push('bottom-10 right-3 md:right-10');
        } else if (position === 'bottom-left') {
            tailwindClasses.push('bottom-10 left-3 md:left-10');
        } else if (position === 'top-right') {
            tailwindClasses.push('top-16 right-3 md:right-10');
        } else if (position === 'top-left') {
            tailwindClasses.push('top-16 left-3 md:left-10');
        }

        return tailwindClasses.join(' ');
    });

    close(id: EntityId) {
        this.stacked = true;
        this.toastsStore.removeToast(id);
    }

    showFlex() {
        this.stacked = false;
    }

    showStacked() {
        this.stacked = true;
    }
}
